import { RootState } from "../../store";
import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { accountsNeedToFetchStatuses } from "@/store/accounts/utils/constants/common";

export const getUsersMeAccountsSelector = (state: RootState) => {
  return cloudChiprApi.endpoints.getUsersMeAccounts.select({
    statuses: accountsNeedToFetchStatuses,
  })(state);
};
